// extracted by mini-css-extract-plugin
export var menuItem = "z_t3 d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "z_t4 d_Z d_bz d_bP";
export var menuMainLink = "z_t5 d_f0 d_dB";
export var menuLink = "z_t6 d_f0 d_dB";
export var icon = "z_qz d_bC d_bP";
export var divider = "z_t7 d_bC d_bP";
export var sublinks = "z_t8";
export var link = "z_mZ";
export var Link = "z_rJ q_rJ q_qW q_rf";